var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3039_35652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0H2C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.89543 23.1046 0 22 0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7656 13.3938V7.69238L23.9132 7.70149V9.27638L22.7403 10.5298L23.9132 11.7947V13.403H22.0405L21.0454 12.3048L20.0572 13.4071L13.7656 13.3938Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4414 12.7687V8.31982H18.2137V9.34471H15.6628V10.0404H18.1529V11.0482H15.6628V11.7315H18.2137V12.7687H14.4414Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1954 12.7688L20.2827 10.5418L18.1953 8.32001H19.811L21.0865 9.73004L22.3656 8.32001H23.9117V8.35501L21.8689 10.5418L23.9117 12.7057V12.7688H22.35L21.0519 11.3446L19.7671 12.7688H18.1954Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2388 2.63184H16.6849L17.544 4.58269V2.63184H20.5639L21.0846 4.09341L21.6071 2.63184H23.9131V8.33323H11.7266L14.2388 2.63184Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7006 3.2514L12.7266 7.69658H14.0805L14.4529 6.80641H16.4708L16.843 7.69658H18.2306L16.2648 3.2514H14.7006ZM14.8702 5.80884L15.4622 4.39377L16.0538 5.80884H14.8702Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2109 7.69575V3.25067L20.1141 3.25721L21.0933 5.98994L22.079 3.25067H23.9106V7.69575L22.732 7.70619V4.65284L21.6194 7.69575H20.5436L19.4079 4.64241V7.69575H18.2109Z",
    fill: "#016FD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3039_35652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.4180d67c60cccacef85b444c2cf5e291.svg";
export { ForwardRef as ReactComponent };